import { Component, ViewChild, ElementRef } from '@angular/core';
import { AlertController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { LoggerProvider, LoggerEvent } from '../../providers/logger/logger';
import { SegmentProvider } from '../../providers/analytics/segment';
import { AnalyticsEventType } from '../../model/types/analytics.const';

@Component({
  selector: 'rmt-promo-code',
  templateUrl: 'rmt-promo-code.html'
})
export class RmtPromoCodeComponent {
  @ViewChild('promoContent', { read: ElementRef }) promoContent;
  @ViewChild('promoLoader', { read: ElementRef }) promoLoader;
  @ViewChild('promoText', { read: ElementRef }) promoText;
  @ViewChild('promoSuccess', { read: ElementRef }) promoSuccess;
  @ViewChild('promoFailed', { read: ElementRef }) promoFailed;
  promoFeeContent: string = '';

  constructor(private alertCtrl: AlertController, private translate: TranslateService, private analytics: SegmentProvider) {}

  show(order, calculateCallback, analyticsLocation: string, log = null, cancelCallback?: any) {
    return new Promise(resolve => {
      this.promoText.nativeElement.style.visibility = 'visible';
      this.promoSuccess.nativeElement.style.display = 'none';
      this.promoFailed.nativeElement.style.display = 'none';
      this.promoLoader.nativeElement.style.display = 'none';

      let ready = false;
      let input;
      const alert = this.alertCtrl.create({
        title: this.translate.instant('page.checkPricesPage.promoCodeModal.promoCode.label'),
        message: '<div class="alert-promocode"></div>',
        cssClass: 'alert-promo',
        inputs: [
          {
            name: 'code',
            id: 'inputPromoCode',
            placeholder: this.translate.instant('page.checkPricesPage.promoCodeModal.promoCode.placeholder')
          }
        ],
        buttons: [
          {
            text: this.translate.instant('page.checkPricesPage.promoCodeModal.genericCancelButton'),
            role: 'cancel',
            handler: () => {
              if (cancelCallback) {
                cancelCallback();
              }
              resolve(false);
            }
          },
          {
            text: this.translate.instant('page.checkPricesPage.promoCodeModal.applyCodeButton'),
            handler: () => {
              if (ready) {
                LoggerProvider.context(log, LoggerEvent.UsePromo, input.value);
                return true;
              }

              LoggerProvider.context(log, LoggerEvent.EnterPromo, input.value);
              this.promoLoader.nativeElement.style.display = '';
              order.promoCode = input.value;              
              calculateCallback().then(result => {                
                this.promoLoader.nativeElement.style.display = 'none';
                this.promoText.nativeElement.style.visibility = 'hidden';

                const alert = document.getElementsByClassName('alert-promo')[0];
                const buttons = alert.getElementsByClassName('alert-button');
                const cancelbutton: any = buttons[0];
                const applybutton: any = buttons[1].getElementsByClassName('button-inner')[0];
                if (result && order.isPromoValid) {
                  this.analytics.trackEvent({eventName: AnalyticsEventType.PromoApplied, analyticsData: {
                    location: analyticsLocation,
                    promoId: '', // TODO
                    promoName: input.value
                  }});

                  input.style.visibility = 'hidden';

                  cancelbutton.style.display = 'none';
                  applybutton.innerText = this.translate.instant('page.checkPricesPage.genericContinueButton');
                  order.promoCode = input.value;
                  this.promoSuccess.nativeElement.style.display = '';
                  this.promoFailed.nativeElement.style.display = 'none';
                  this.promoFeeContent = order.promoAmount > 0 
                    ? this.translate.instant('page.checkPricesPage.genericPromoCodeAcceptedMessage')
                    : this.translate.instant('page.checkPricesPage.promoCodeAcceptedMessage').replace('{{promoFee}}', order.customerFee);
                  ready = true;
                } else {
                  this.analytics.trackEvent({eventName: AnalyticsEventType.PromoFailed, analyticsData: {
                    location: analyticsLocation,
                    errorType: 'promocodeError', 
                    promoId: '', // TODO
                    promoName: input.value
                  }});

                  applybutton.innerText = this.translate.instant('page.checkPricesPage.promoCodeModal.applyCodeButton');
                  this.promoSuccess.nativeElement.style.display = 'none';
                  this.promoFailed.nativeElement.style.display = '';
                  ready = false;
                }
                resolve(ready);
              });
              order.promoCode = null; // remove it as it will only be set when apply is clicked again
              return false;
            }
          }
        ]
      });
      alert.setMode('ios');
      alert.present();
      window.requestAnimationFrame(() => {
        const promocode = document.getElementsByClassName('alert-promocode')[0];
        const inputs = (<any>promocode.parentNode.parentNode).getElementsByClassName('alert-input-group')[0];
        input = inputs.getElementsByClassName('alert-input')[0];
        inputs.appendChild(this.promoContent.nativeElement);
        this.promoContent.nativeElement.style.display = '';
        var tempAlert=document.getElementsByClassName('alert-promo')[0];              
              var tempButtons = tempAlert.getElementsByClassName('alert-button');
              if(tempButtons.length==2){  
                  tempButtons[0].id='cancelBtnPromoCode';
                  tempButtons[1].id='applyCodeBtnPromoCode';
              }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-promo-code/rmt-promo-code.ts